module.exports = __webpack_public_path__ + "static/media/battery_dashboard_en.114b3364.png";